(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const cleanExample = (value) => String(value || '').trim();
  const toTitleNameLoose = (value) => String(value || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/(^|[\s-])(\p{L})/gu, (match, separator, letter) => `${separator}${letter.toLocaleUpperCase('tr-TR')}`);
  const toTitleName = (value) => toTitleNameLoose(cleanExample(value));
  const toUpperTitleLoose = (value) => String(value || '').toLocaleUpperCase('tr-TR');
  const toUpperTitle = (value) => toUpperTitleLoose(cleanExample(value));

  const initNameplatePersonalizer = (root) => {
    if (root.dataset.renaoNameplateReady === 'true') return;
    root.dataset.renaoNameplateReady = 'true';

    const preview = root.querySelector('[data-renao-nameplate-preview]');
    const plate = root.querySelector('.renao-nameplate');
    const nameInput = root.querySelector('[data-renao-nameplate-name-input]');
    const titleInput = root.querySelector('[data-renao-nameplate-title-input]');
    const namePreview = root.querySelector('[data-renao-nameplate-name-preview]');
    const titlePreview = root.querySelector('[data-renao-nameplate-title-preview]');
    const nameCount = root.querySelector('[data-renao-nameplate-name-count]');
    const titleCount = root.querySelector('[data-renao-nameplate-title-count]');
    const designProperty = root.querySelector('[data-renao-nameplate-design-property]');
    const privateDesign = root.querySelector('[data-renao-nameplate-private-design]');
    const nameFontProperty = root.querySelector('[data-renao-nameplate-name-font-property]');
    const titleFontProperty = root.querySelector('[data-renao-nameplate-title-font-property]');
    const colorProperty = root.querySelector('[data-renao-nameplate-color-property]');
    const originalSwatch = root.querySelector('[data-renao-nameplate-original-swatch]');
    const proofOpen = root.querySelector('[data-renao-nameplate-proof-open]');
    const proofModal = root.querySelector('[data-renao-nameplate-proof-modal]');
    const proofStage = root.querySelector('[data-renao-nameplate-proof-stage]');
    const proofCloseButtons = root.querySelectorAll('[data-renao-nameplate-proof-close]');
    const previewOriginalParent = preview?.parentElement || null;
    const previewOriginalNext = preview?.nextSibling || null;

    if (!preview || !plate || !nameInput || !titleInput) return;
    if (proofModal && proofModal.parentElement !== document.body) document.body.appendChild(proofModal);

    let selectedColorMode = 'original';

    const getProductForm = () => root.closest('form');

    const getProductMediaWrapper = () => {
      const product = root.closest('.product') || document.querySelector('.product');
      return product ? product.querySelector('.product__media-wrapper') : null;
    };

    const showProductMedia = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (mediaWrapper) {
        mediaWrapper.classList.remove('has-renao-live-preview');
        mediaWrapper.classList.remove('is-renao-media-returning');
        void mediaWrapper.offsetWidth;
        mediaWrapper.classList.add('is-renao-media-returning');
        window.setTimeout(() => mediaWrapper.classList.remove('is-renao-media-returning'), 900);
      }

      root.classList.remove('has-renao-live-preview');
      if (previewOriginalParent && preview.parentElement !== previewOriginalParent) {
        previewOriginalParent.insertBefore(preview, previewOriginalNext);
      }
    };

    const ensureLivePreviewDock = (mediaWrapper) => {
      let dock = mediaWrapper.querySelector('[data-renao-nameplate-live-preview-dock]');
      if (dock) return dock;

      dock = document.createElement('div');
      dock.className = 'renao-live-preview-dock renao-live-preview-dock--nameplate';
      dock.dataset.renaoNameplateLivePreviewDock = '';
      dock.innerHTML = `
        <div class="renao-live-preview-dock__bar">
          <span class="renao-live-preview-dock__title">
            <span class="renao-live-preview-dock__mark" aria-hidden="true"></span>
            <span>
              <strong>Canlı önizleme</strong>
              <small>Baskıdan önceki son tasarım</small>
            </span>
          </span>
          <button type="button" data-renao-nameplate-show-product-media>Ürün fotoğrafları</button>
        </div>
        <div class="renao-live-preview-dock__slot" data-renao-nameplate-live-preview-slot></div>
      `;
      mediaWrapper.insertBefore(dock, mediaWrapper.firstChild);
      dock.querySelector('[data-renao-nameplate-show-product-media]')?.addEventListener('click', showProductMedia);
      return dock;
    };

    const fitText = (element, maxSize, minSize) => {
      if (!element) return;
      element.style.fontSize = `${maxSize}px`;
      const parentWidth = element.parentElement ? element.parentElement.clientWidth * 0.9 : 0;
      if (!parentWidth) return;
      let size = maxSize;
      while (element.scrollWidth > parentWidth && size > minSize) {
        size -= 1;
        element.style.fontSize = `${size}px`;
      }
    };

    const fitPreviewText = () => {
      const plateWidth = plate.getBoundingClientRect().width || 860;
      const isPdfDesign = [
        'design-01',
        'design-02',
        'design-03',
        'design-04',
        'design-05',
        'design-06',
        'design-07',
        'design-08',
        'design-09',
        'design-10',
        'design-11',
        'design-12',
        'design-13',
        'design-14',
        'design-15',
        'design-16',
        'design-17',
        'design-18',
        'design-19',
        'design-20',
        'design-21',
        'design-22',
        'design-23',
        'design-24',
      ]
        .includes(plate.dataset.renaoNameplateDesign);
      const isCompactPdfDesign = ['design-20', 'design-21', 'design-22', 'design-23', 'design-24']
        .includes(plate.dataset.renaoNameplateDesign);
      const isMobilePreview = window.matchMedia('(max-width: 749px)').matches;
      const nameFont = namePreview.dataset.renaoNameplateNameFont || '';
      const nameFontScale = nameFont === 'acardia'
        ? 0.66
        : nameFont === 'font-00619'
          ? 1.38
          : 1;
      const nameMaxBase = isCompactPdfDesign
        ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.047 : 0.058)), 14, isMobilePreview ? 34 : 60)
        : isPdfDesign
          ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.052 : 0.067)), 15, isMobilePreview ? 38 : 70)
          : 76;
      const nameMinBase = isCompactPdfDesign
        ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.028 : 0.035)), 12, isMobilePreview ? 18 : 26)
        : isPdfDesign
          ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.031 : 0.04)), 12, isMobilePreview ? 20 : 29)
          : 30;
      const nameMax = Math.round(nameMaxBase * nameFontScale);
      const nameMin = Math.round(nameMinBase * nameFontScale);
      const titleMax = isCompactPdfDesign
        ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.016 : 0.024)), 8, isMobilePreview ? 13 : 24)
        : isPdfDesign
          ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.018 : 0.027)), 8, isMobilePreview ? 14 : 29)
          : 28;
      const titleMin = isCompactPdfDesign
        ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.012 : 0.016)), 7, isMobilePreview ? 10 : 13)
        : isPdfDesign
          ? clamp(Math.round(plateWidth * (isMobilePreview ? 0.013 : 0.019)), 7, isMobilePreview ? 11 : 15)
          : 13;
      fitText(namePreview, nameMax, nameMin);
      fitText(titlePreview, titleMax, titleMin);
    };

    const showLivePreview = () => {
      const mediaWrapper = getProductMediaWrapper();
      if (!mediaWrapper) return;

      const dock = ensureLivePreviewDock(mediaWrapper);
      const slot = dock.querySelector('[data-renao-nameplate-live-preview-slot]');
      if (!slot) return;

      if (preview.parentElement !== slot) slot.appendChild(preview);
      mediaWrapper.classList.remove('is-renao-media-returning');
      mediaWrapper.classList.add('has-renao-live-preview');
      root.classList.add('has-renao-live-preview');
      window.requestAnimationFrame(() => {
        fitPreviewText();
        window.requestAnimationFrame(fitPreviewText);
      });
      window.setTimeout(fitPreviewText, 260);
    };

    const syncText = () => {
      const name = toTitleName(nameInput.value || nameInput.placeholder || 'Dr. Berfin Yılmaz');
      const title = toUpperTitle(titleInput.value || titleInput.placeholder || 'UZMAN ESTETİSYEN');
      namePreview.textContent = name;
      titlePreview.textContent = title;
      if (nameCount) nameCount.textContent = `${nameInput.value.length}/${nameInput.maxLength}`;
      if (titleCount) titleCount.textContent = `${titleInput.value.length}/${titleInput.maxLength}`;
      root.classList.remove('has-renao-nameplate-name-error', 'has-renao-nameplate-title-error');
      fitPreviewText();
    };

    const normalizeTextInputs = () => {
      if (nameInput.value.trim()) nameInput.value = toTitleName(nameInput.value);
      if (titleInput.value.trim()) titleInput.value = toUpperTitle(titleInput.value);
      syncText();
    };

    const normalizeActiveTextInput = (input) => {
      const formattedValue = input === nameInput
        ? toTitleNameLoose(input.value)
        : toUpperTitleLoose(input.value);
      if (input.value === formattedValue) return;

      const selectionStart = input.selectionStart;
      const selectionEnd = input.selectionEnd;
      input.value = formattedValue;
      if (document.activeElement === input && selectionStart !== null && selectionEnd !== null) {
        input.setSelectionRange(selectionStart, selectionEnd);
      }
    };

    const selectButton = (buttons, selectedButton) => {
      buttons.forEach((button) => {
        const isSelected = button === selectedButton;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    };

    const getSelectedDesignButton = () => root.querySelector('[data-renao-nameplate-design-option].is-selected')
      || root.querySelector('[data-renao-nameplate-design-option]');

    const getOriginalColor = () => getSelectedDesignButton()?.dataset.renaoNameplateOriginalColor || '#ffffff';

    const syncOriginalSwatch = () => {
      if (originalSwatch) originalSwatch.style.setProperty('--rn-nameplate-swatch', getOriginalColor());
    };

    const selectColor = (buttonOrMode) => {
      const mode = typeof buttonOrMode === 'string'
        ? buttonOrMode
        : buttonOrMode?.dataset.renaoNameplateColorOption || 'original';
      selectedColorMode = mode;

      const color = mode === 'black'
        ? '#000000'
        : mode === 'white'
          ? '#ffffff'
          : getOriginalColor();
      const label = mode === 'black'
        ? 'Siyah'
        : mode === 'white'
          ? 'Beyaz'
          : `Orijinal (${color})`;

      plate.style.setProperty('--rn-nameplate-copy-color', color);
      if (colorProperty) colorProperty.value = label;
      root.querySelectorAll('[data-renao-nameplate-color-option]').forEach((button) => {
        const isSelected = button.dataset.renaoNameplateColorOption === mode;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      syncOriginalSwatch();
    };

    const selectDesign = (button) => {
      const design = button.dataset.renaoNameplateDesignOption || 'design-01';
      const label = button.dataset.renaoNameplateDesignLabel || 'Tasarım 1';
      plate.dataset.renaoNameplateDesign = design;
      if (designProperty) designProperty.value = label;
      if (privateDesign) privateDesign.value = `İsim plaketi - ${label}`;
      selectButton(root.querySelectorAll('[data-renao-nameplate-design-option]'), button);
      syncOriginalSwatch();
      if (selectedColorMode === 'original') selectColor('original');
      showLivePreview();
    };

    const selectFont = (button, target) => {
      const value = target === 'name'
        ? button.dataset.renaoNameplateNameFontOption
        : button.dataset.renaoNameplateTitleFontOption;
      const label = button.dataset.renaoNameplateFontLabel || value;
      const buttons = target === 'name'
        ? root.querySelectorAll('[data-renao-nameplate-name-font-option]')
        : root.querySelectorAll('[data-renao-nameplate-title-font-option]');
      const previewTarget = target === 'name' ? namePreview : titlePreview;
      const property = target === 'name' ? nameFontProperty : titleFontProperty;

      previewTarget.dataset[target === 'name' ? 'renaoNameplateNameFont' : 'renaoNameplateTitleFont'] = value;
      if (property) property.value = label;
      selectButton(buttons, button);
      fitPreviewText();
      showLivePreview();
    };

    const openProofModal = () => {
      if (!proofModal || !proofStage) return;
      showLivePreview();
      fitPreviewText();
      proofStage.innerHTML = '';
      const clone = plate.cloneNode(true);
      const plateRect = plate.getBoundingClientRect();
      const proofWidth = Math.round(plateRect.width);
      if (proofWidth > 0) clone.style.width = `${proofWidth}px`;
      clone.style.maxWidth = '100%';
      proofStage.appendChild(clone);
      proofModal.hidden = false;
      document.documentElement.classList.add('renao-modal-open');
    };

    const closeProofModal = () => {
      if (!proofModal) return;
      proofModal.hidden = true;
      document.documentElement.classList.remove('renao-modal-open');
    };

    const restoreEditState = () => {
      const params = new URLSearchParams(window.location.search);
      const editKey = params.get('renao_edit');
      if (!editKey) return;

      let editState = null;
      try {
        editState = JSON.parse(window.sessionStorage.getItem(`renaoCartEdit:${editKey}`) || 'null');
      } catch (error) {
        console.warn('Renao nameplate cart edit state could not be restored.', error);
      }
      if (!editState?.properties) return;

      const properties = editState.properties;
      const productForm = getProductForm();
      if (productForm) {
        productForm.dataset.renaoEditKey = editState.key || editKey;
        productForm.dataset.renaoEditStorageKey = editState.key ? `renaoCartEdit:${editState.key}` : '';
        const quantityInput = productForm.querySelector('input[name="quantity"]');
        if (quantityInput && editState.quantity) quantityInput.value = editState.quantity;
      }

      if (properties['İsim Soyisim']) nameInput.value = properties['İsim Soyisim'];
      if (properties['Ünvan']) titleInput.value = properties['Ünvan'];

      const designButton = Array.from(root.querySelectorAll('[data-renao-nameplate-design-option]'))
        .find((button) => button.dataset.renaoNameplateDesignLabel === properties.Tasarım);
      if (designButton) selectDesign(designButton);

      const nameFontButton = Array.from(root.querySelectorAll('[data-renao-nameplate-name-font-option]'))
        .find((button) => button.dataset.renaoNameplateFontLabel === properties['İsim Fontu']);
      if (nameFontButton) selectFont(nameFontButton, 'name');

      const titleFontButton = Array.from(root.querySelectorAll('[data-renao-nameplate-title-font-option]'))
        .find((button) => button.dataset.renaoNameplateFontLabel === properties['Ünvan Fontu']);
      if (titleFontButton) selectFont(titleFontButton, 'title');

      if (properties['Yazı Rengi']) {
        if (properties['Yazı Rengi'] === 'Beyaz') selectColor('white');
        else if (properties['Yazı Rengi'] === 'Siyah') selectColor('black');
        else selectColor('original');
      }

      const noteInput = root.querySelector('textarea[name="properties[Not]"]');
      if (noteInput && Object.prototype.hasOwnProperty.call(properties, 'Not')) {
        noteInput.value = String(properties.Not || '').slice(0, noteInput.maxLength || 140);
      }
      syncText();
    };

    root.addEventListener('click', (event) => {
      const designButton = event.target.closest('[data-renao-nameplate-design-option]');
      if (designButton) {
        selectDesign(designButton);
        return;
      }

      const nameFontButton = event.target.closest('[data-renao-nameplate-name-font-option]');
      if (nameFontButton) {
        selectFont(nameFontButton, 'name');
        return;
      }

      const titleFontButton = event.target.closest('[data-renao-nameplate-title-font-option]');
      if (titleFontButton) {
        selectFont(titleFontButton, 'title');
        return;
      }

      const colorButton = event.target.closest('[data-renao-nameplate-color-option]');
      if (colorButton) {
        selectColor(colorButton);
      }
    });

    root.addEventListener('input', (event) => {
      if (event.target === nameInput || event.target === titleInput) {
        normalizeActiveTextInput(event.target);
        syncText();
        showLivePreview();
      }
    });
    root.addEventListener('focusout', (event) => {
      if (event.target === nameInput || event.target === titleInput) normalizeTextInputs();
    });
    root.addEventListener('focusin', showLivePreview);
    proofOpen?.addEventListener('click', openProofModal);
    proofCloseButtons.forEach((button) => button.addEventListener('click', closeProofModal));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && proofModal && !proofModal.hidden) closeProofModal();
    });

    restoreEditState();
    syncOriginalSwatch();
    selectColor(selectedColorMode);
    syncText();
  };

  const boot = () => {
    document.querySelectorAll('[data-renao-nameplate-personalizer]').forEach(initNameplatePersonalizer);
  };

  document.addEventListener('renao:nameplate:validate', (event) => {
    const root = event.target.closest('[data-renao-nameplate-personalizer]');
    if (!root) return;

    const nameInput = root.querySelector('[data-renao-nameplate-name-input]');
    const titleInput = root.querySelector('[data-renao-nameplate-title-input]');
    const missingName = !String(nameInput?.value || '').trim();
    const missingTitle = !String(titleInput?.value || '').trim();
    if (!missingName && nameInput) nameInput.value = toTitleName(nameInput.value);
    if (!missingTitle && titleInput) titleInput.value = toUpperTitle(titleInput.value);
    root.classList.toggle('has-renao-nameplate-name-error', missingName);
    root.classList.toggle('has-renao-nameplate-title-error', missingTitle);
    if (!missingName && !missingTitle) {
      // On input the live preview is moved from the form into the product-media
      // dock. Validation must not fail just because those preview nodes are no
      // longer descendants of the personalizer root.
      const previewDock = root.closest('.product')?.querySelector('[data-renao-nameplate-live-preview-dock]');
      const namePreview = root.querySelector('[data-renao-nameplate-name-preview]')
        || previewDock?.querySelector('[data-renao-nameplate-name-preview]');
      const titlePreview = root.querySelector('[data-renao-nameplate-title-preview]')
        || previewDock?.querySelector('[data-renao-nameplate-title-preview]');
      if (namePreview) namePreview.textContent = nameInput.value;
      if (titlePreview) titlePreview.textContent = titleInput.value;
    }
    event.detail.valid = !missingName && !missingTitle;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
